import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

function MetaDecorators() {
  const { domainDetails } = useSelector((state) => state.listings);
  return (
    <Helmet>
      <title>{domainDetails.name && domainDetails.name}</title>
      <link rel='icon' type='image/png' href={domainDetails.image && domainDetails.image} sizes='16x16' />
    </Helmet>
  );
}

export default MetaDecorators;
